import { Box } from "@mui/material";
import { ReactElement } from "react";

import ConfirmationDialog from "../Modal/ConfirmationDialog";
import { ContentContainer } from "./LockConfirmationDailog.styles";
import { useLockConfirmationDailog } from "./useLockConfirmationDailog.hooks";

type Props = {
  lockedPrompt: boolean;
  setLockedPrompt: (value: boolean) => void;
};

const LockConfirmationDialog = ({
  lockedPrompt,
  setLockedPrompt,
}: Props): ReactElement => {
  const { closeLockedDialog } = useLockConfirmationDailog({ setLockedPrompt });

  return (
    <ConfirmationDialog
      open={lockedPrompt}
      onClose={closeLockedDialog}
      id="lock_prompt"
      actions={[
        {
          label: "Cancel",
          onClick: closeLockedDialog,
          id: "close_dialog",
          variant: "outlined",
          color: "error",
        },
      ]}
      content={
        <Box component="span">
          This feature is currently available on the full version of the Ark
          platform, please contact
          <ContentContainer> sales@arkpes.com </ContentContainer> or your fund
          administrator for access.
        </Box>
      }
      title="Locked"
    />
  );
};

export default LockConfirmationDialog;
